import { render } from "./WhyWe.vue?vue&type=template&id=dafd8328"
const script = {}

import "./WhyWe.vue?vue&type=style&index=0&id=dafd8328&lang=scss"

import exportComponent from "/builds/frontend/landings/mobigiru.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__